import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CurrencyTypeActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';

@Injectable()
export class CurrencyTypeEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService
  ) {}

  private common = new Common();

  getcurrencyType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrencyTypeActions.getcurrencyType),
      switchMap((action) =>
        this.onboardingProductsService.getcurrencyType(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            CurrencyTypeActions.getcurrencyTypeSucess({ response: res })
          ),
          catchError((error) =>
            of(
              CurrencyTypeActions.getcurrencyTypeError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
